module.exports = __webpack_public_path__ + "img/tarj1-1.6f6369c9.png";